import { render, staticRenderFns } from "./dadosNF.vue?vue&type=template&id=4b3ae7db"
import script from "./dadosNF.vue?vue&type=script&lang=js"
export * from "./dadosNF.vue?vue&type=script&lang=js"
import style0 from "./dadosNF.vue?vue&type=style&index=0&id=4b3ae7db&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports